import React from "react";
import Confetti from "react-confetti";
import "./Easter.css";

const Easter = () => {
  const { innerHeight, innerWidth } = window;

  return (
    <div className="body">
      <Confetti width={innerWidth} height={innerHeight} />
      <h1 className={"rainbowText"}>Reactive-Karan</h1>
    </div>
  );
};

export default Easter;
